import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import MessageCenterPage from "../../components/messageCenter";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const Messaging = props => (
  <ProtectedRoute>
    <main>
    <Helmet title="Messaging" />
    <Layout>
      <Routes>
        <Route path="/" element={<MessageCenterPage />} />
      </Routes>
    </Layout>
    </main>
  </ProtectedRoute>
);

export default Messaging;
